export const DATA_SOURCE_TYPES = [{ label: 'API', value: 'api' }, { label: 'Entity', value: 'entity' }];
export const DATA_BOARD_TYPES = {display:'display',aggregator:'aggregator'}
export const OVERVIEW_TRACKER_STATUSES = {pending:'pending',approved:'approved',rejected:'rejected'};
export const FILTER_WIDGET_FILTERTYPES = [{label:'dropdown',id:'dropdown'},{label:'date range',id:'date_range'}];
export const DATALIST_FILE_DOWNLOADTYPES = ['excel','pdf'];
export const PRE_CONFIGURED_APIS = [{
    "apiId": "entitySubmisionsList",
    "apiName": "Entity submisions",
    "apiURL": "/api/v1/entitySubmissions/list",
    "method": "POST",
    "requestBody": {},
    "headers": {},
    "pathVariables": {},
    "queryParams": [],
    "authenticatedApiId": null,
    "variables": [],
    "isAuthenticatedApi": false,
    "authType": null,
    "apiResponce": [
        {
            "value": "Others",
            "id": "Others",
            "total_count": 34,
            "Others": 14,
            "Rejected": 2,
            "Approved": 1,
            "Pending": 17
        },
        {
            "value": "Performed Under Supervision",
            "id": "8dabd7ef-6229-4a4b-807b-9fdc4d2e0206",
            "total_count": 2,
            "Pending": 2
        },
        {
            "value": "Observation",
            "id": "8dabd7ef-6229-4a4b-807b-9fdc4d2e0206",
            "total_count": 2,
            "Pending": 2
        },
        {
            "value": "Performed Individually",
            "id": "8dabd7ef-6229-4a4b-807b-9fdc4d2e0206",
            "total_count": 1,
            "Pending": 1
        }
    ]
},
{
    "apiId": "dashboardUserBased",
    "apiName": "user based",
    "apiURL": "/api/v1/dashbaord/user-based",
    "method": "POST",
    "requestBody": {},
    "headers": {},
    "pathVariables": {},
    "queryParams": [],
    "authenticatedApiId": null,
    "variables": [],
    "isAuthenticatedApi": false,
    "authType": null,
    'apiResponce': [
        {
            "user_id": "16bf2f19-28ef-4814-8c0d-4c3fe8c5a7a6",
            "username": "Test Incharge",
            "total": 11,
            "approved": 3,
            "rejected": 3,
            "none": 5
        },
        {
            "user_id": "7579071d-754c-4d72-b928-9612cc53e0df",
            "username": "Test Supervisor",
            "total": 19,
            "approved": 6,
            "rejected": 6,
            "none": 7
        },
        {
            "user_id": "7e798628-c94d-4bfd-b2a8-41d62eb375e3",
            "username": "Test Trainee",
            "total": 38,
            "approved": 11,
            "rejected": 11,
            "none": 16
        },
        {
            "user_id": "8456a2f7-e8a0-4967-952f-36bb54f70055",
            "username": "Test Manager",
            "total": 3,
            "approved": 1,
            "rejected": 1,
            "none": 1
        },
        {
            "user_id": "9a4bac06-eb20-45fb-acce-f1e00e30c3ab",
            "username": "Test Junior",
            "total": 12,
            "approved": 4,
            "rejected": 4,
            "none": 4
        },
        {
            "user_id": "bbc193cb-84e1-48b6-ab41-c45b0d9cbd8c",
            "username": "Test Senior",
            "total": 3,
            "approved": 1,
            "rejected": 1,
            "none": 1
        }
    ]
},
{
    "apiId": "dashBoardWorkflowBased",
    "apiName": "workflow based",
    "apiURL": "/api/v1/dashbaord/workflow-based",
    "method": "POST",
    "requestBody": {},
    "headers": {},
    "pathVariables": {},
    "queryParams": [],
    "authenticatedApiId": null,
    "variables": [],
    "isAuthenticatedApi": false,
    "authType": null,
    "apiResponce":[
        {
            "value": "ABG SAMPLE",
            "total_count": 2,
            "approved_count": 0,
            "rejected_count": 0,
            "pending_count": 2
        },
        {
            "value": "ABG Sample",
            "total_count": 20,
            "approved_count": 1,
            "rejected_count": 2,
            "pending_count": 17
        }
    ]
},]
